export default __webpack_public_path__ + "static/media/Apple_Logo.8c4986ee.svg";